export default __webpack_public_path__ + "static/media/excellent1.fde7bd66.svg";